var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SliderDotContainer, SliderDotContent, Tag, TagContainer, } from './SliderDot.style';
var getTouchPosition = function (e) {
    return e.touches[0].pageX;
};
var getMousePosition = function (e) { return e.pageX; };
var useMouseMove = function (_a) {
    var onMove = _a.onMove, onRest = _a.onRest;
    var listeners = React.useRef({});
    var restPosition = React.useRef(0);
    var addListener = function (listenerName, listener) {
        document.addEventListener(listenerName, listener);
        listeners.current[listenerName] = listener;
    };
    var removeListener = function (listenerName) {
        if (listeners.current[listenerName]) {
            document.removeEventListener(listenerName, listeners.current[listenerName]);
            delete listeners.current[listenerName];
        }
    };
    var handleMouseDown = function (e) {
        var handleMouseMove = function (e) {
            onMove(getMousePosition(e) - restPosition.current);
            e.preventDefault();
        };
        var handleMouseUp = function () {
            removeListener('mousemove');
            removeListener('mouseup');
            onRest();
        };
        if (e.button === 0) {
            addListener('mousemove', handleMouseMove);
            addListener('mouseup', handleMouseUp);
            restPosition.current = getMousePosition(e);
        }
    };
    var handleTouchStart = function (e) {
        var handleTouchMove = function (e) {
            onMove(getTouchPosition(e) - restPosition.current);
            e.preventDefault();
        };
        var handleTouchEnd = function () {
            removeListener('touchmove');
            removeListener('touchend');
            onRest();
        };
        if (e.targetTouches.length === 1) {
            addListener('touchmove', handleTouchMove);
            addListener('touchend', handleTouchEnd);
            restPosition.current = getTouchPosition(e);
        }
    };
    return { onMouseDown: handleMouseDown, onTouchStart: handleTouchStart };
};
export var SliderDot = function (_a) {
    var position = _a.position, onMove = _a.onMove, onRest = _a.onRest, innerColor = _a.innerColor, _b = _a.large, large = _b === void 0 ? false : _b, dotType = _a.dotType, tooltip = _a.tooltip;
    var eventProps = useMouseMove({ onMove: onMove, onRest: onRest });
    return (React.createElement(SliderDotContainer, __assign({ "data-testid": "slider-dot", style: { left: "".concat(position, "%") }, "data-large": large, "data-dotType": dotType }, eventProps),
        React.createElement(SliderDotContent, { style: { backgroundColor: innerColor }, "data-dotType": dotType }),
        dotType === 'tag' && (React.createElement(TagContainer, null,
            React.createElement(Tag, { interactive: true, "data-testid": "slider-tag" }, tooltip.content)))));
};
//# sourceMappingURL=SliderDot.js.map